import type { PropsWithChildren, ReactNode } from "react";
import React from "react";
import { Layout, Tutorial } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { useMedia, View } from "tamagui";

import { api } from "~/utils/api";
import { useMe } from "~/hooks";
import { Footer } from "../layout";

const images = {
  "1": require("../../assets/onboarding/frame-1.png"),
  "2": require("../../assets/onboarding/frame-2.png"),
  "3": require("../../assets/onboarding/frame-3.png"),
};

export const WithTutorial: React.FC<
  PropsWithChildren & { header?: ReactNode }
> = ({ children, header }) => {
  const { sm } = useMedia();
  const { t } = useTranslation("onboarding");
  const onboarding = t("Text.selfDiscoveryIntro", { returnObjects: true });
  const person = useMe();
  const utils = api.useUtils();

  const { mutate } = api.patient.resetGreeting.useMutation({
    onMutate: () => {
      const prevPerson = utils.context.person.getData();

      if (prevPerson && typeof prevPerson === "object") {
        utils.context.person.setData(undefined, {
          ...prevPerson,
          id: prevPerson.id,
          greeting: false,
        });
      }
      return { prevPerson };
    },
    onError: (_error, _data, context) => {
      const prevPerson = context?.prevPerson;

      if (prevPerson && typeof prevPerson === "object") {
        utils.context.person.setData(undefined, {
          ...prevPerson,
          id: prevPerson.id,
        });
      }
    },
  });

  const onbordingWithImages = onboarding.map((item) => {
    return {
      ...item,
      content: {
        image: item.content?.image
          ? images[item.content?.image as keyof typeof images]
          : null,
      },
    };
  });

  const isOpen = !!person?.greeting;

  if (!isOpen) return children;

  return (
    <Layout mode="tutorial" variant="dualbackground">
      {header}
      <Tutorial.Provider onClose={() => mutate()} data={onbordingWithImages}>
        <View
          data-id={"tutorial"}
          alignSelf="center"
          flexDirection="row"
          maxWidth={1248}
          paddingHorizontal={"$3"}
          flex={2}
          width={"100%"}
          paddingTop={"$8"}
          $sm={{
            flexDirection: "column-reverse",
            alignSelf: "flex-start",
            paddingTop: "$4",
            gap: "$2.5",
          }}
        >
          <View
            flex={1}
            width={"50%"}
            justifyContent="center"
            alignSelf="center"
            paddingRight={"$5.1"}
            $sm={{
              paddingRight: 0,
              width: "100%",
            }}
          >
            <View
              maxWidth={558}
              gap={"$12"}
              $sm={{
                width: "100%",
                maxWidth: 1000,
                gap: "$3",
              }}
            >
              <View
                gap={"$4"}
                $sm={{
                  gap: "$2",
                }}
              >
                <View
                  minHeight={110}
                  $sm={{
                    height: "auto",
                  }}
                >
                  <Tutorial.Title />
                </View>

                <Tutorial.Progress />
                <Tutorial.Description />
              </View>
              <Tutorial.Controls />
            </View>
          </View>

          <View
            justifyContent="center"
            alignSelf="center"
            paddingLeft={"$5.1"}
            width={"50%"}
            flex={1}
            $sm={{
              paddingLeft: 0,
              maxWidth: 1000,
              width: "100%",
              alignItems: "center",
            }}
          >
            <Tutorial.Image />
          </View>
        </View>
      </Tutorial.Provider>
      {sm && (
        <View paddingTop={"$5"}>
          <Footer />
        </View>
      )}
    </Layout>
  );
};
